import { AppCacheStatus as Status } from '@fullstory/redux-util/utils';
import { GenerateSearchieResponseProto } from '@fullstory/proto/fs/services/alexa';

export enum SearchieActionTypes {
  UserTrendsSettingsChange = 'searchies/USER_TRENDS_SETTINGS_CHANGE',
  MobileDeviceSettingsChange = 'searchies/MOBILE_DEVICE_SETTINGS_CHANGE',
  RageClicksSettingsChange = 'searchies/RAGE_CLICK_SETTINGS_CHANGE',
  DeadClicksSettingsChange = 'searchies/DEAD_CLICK_SETTINGS_CHANGE',
  ErrorClicksSettingsChange = 'searchies/ERROR_CLICK_SETTINGS_CHANGE',
}

export enum SearchieRequestTypes {
  SearchieSuggestionRequest = 'searchies/SEARCHIE_SUGGESTION_REQUEST',
  SearchieSuggestionSuccess = 'searchies/SEARCHIE_SUGGESTION_SUCCESS',
  SearchieSuggestionFailure = 'searchies/SEARCHIE_SUGGESTION_FAILURE',
  UserDetailsRequest = 'searchies/USER_DETAILS_REQUEST',
  UserDetailsRequestSuccess = 'searchies/USER_DETAILS_REQUEST_SUCCESS',
  UserDetailsRequestFailure = 'searchies/USER_DETAILS_REQUEST_FAILURE',
  AppCacheRequest = 'searchies/APP_CACHE_REQUEST',
  AppCacheSuccess = 'searchies/APP_CACHE_SUCCESS',
  AppCacheFailure = 'searchies/APP_CACHE_FAILURE',
  SearchieAppCacheIsLoading = 'searchies/APP_CACHE_IS_LOADING',
  SearchieAppCacheLoadFailed = 'searchies/APP_CACHE_LOAD_FAILED',
  SearchieAppCacheRefetching = 'searchies/APP_CACHE_IS_REFETCHING',
  SearchieAppCacheHasData = 'searchies/APP_CACHE_HAS_DATA',
  SearchieAppCacheFresh = 'searchies/APP_CACHE_FRESH',
  SearchieAppCacheSwap = 'searchies/APP_CACHE_SWAP',
  SearchieAppCacheClear = 'searchies/APP_CACHE_CLEAR',
  GenerateSearchieRequest = 'searchies/GENERATE_SEARCHIE_REQUEST',
  GenerateSearchieSuccess = 'searchies/GENERATE_SEARCHIE_SUCCESS',
  GenerateSearchieFailure = 'searchies/GENERATE_SEARCHIE_FAILURE',
}

export interface AppCacheData {
  status: Status;
  ready: boolean;
  data: GenerateSearchieResponseProto | null;
}
